import { map, Observable, switchMap } from "rxjs";
import { ActivatedRouteSnapshot, RedirectCommand, Router, RouterStateSnapshot } from "@angular/router";
import { singleStrategyInStrategyGroup, StrategyGroupEx } from "@front/m19-models";
import { inject } from "@angular/core";
import { AccountSelectionService, SpStrategyService } from "@front/m19-services";

export const strategyGroupPageGuard: (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => Observable<boolean | RedirectCommand> = (route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
  const router = inject(Router);
  const accountSelectionService = inject(AccountSelectionService);
  const spStrategyService = inject(SpStrategyService);

  const params = route.paramMap;

  const groupId = Number(params.get("id"));

  return accountSelectionService.singleAccountMarketplaceSelection$.pipe(
    switchMap((am) => spStrategyService.getStrategyGroups(am.accountId, am.marketplace)),
    map((strategyGroups) => strategyGroups.get(groupId)),
    map((strategyGroup: StrategyGroupEx | undefined) => {
      if (strategyGroup && strategyGroup.strategies && singleStrategyInStrategyGroup(strategyGroup)) {
        return new RedirectCommand(
          router.createUrlTree([
            "/advertising/sponsored-product/strategy-group",
            groupId,
            strategyGroup.strategies[0].strategyId,
          ]),
        );
      }

      return true;
    }),
  );
};
